import { CityModel, DeepPartial, RiskAddressModel } from '@/types';

export const getCityModelByAddressModel = (address: DeepPartial<RiskAddressModel>): CityModel => {
  if (!Boolean(address?.city) || !Boolean(address?.state)) return undefined;

  return {
    name: address.city,
    stateAbbr: address.state,
    place: `${address.city} - ${address.state}`,
  };
};
